import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-relationship-consequence',
  templateUrl: './relationship-consequence.component.html',
  styleUrls: ['./relationship-consequence.component.scss'],
})
export class RelationshipConsequenceComponent {
  @Input() relateToLocation: any;
  faTimes = faTimes;
  faPlus = faPlus;
  @Input() partyRoles: any;
  @Input() partyRelationships: any;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();

  constructor(
    private router: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
    this.debouncer.pipe(debounce(() => interval(1000))).subscribe((value) => this.inputChangeEmitter.emit(value));
  }

  initConsequenceObject(): void {
    console.log(this.relateToLocation);
    var tmpObj = {
      class:
        'com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Consequences$RelateToLocation',
    };
    if (this.relateToLocation) {
      this.relateToLocation.push(tmpObj);
    } else {
      this.relateToLocation = [];
      this.relateToLocation.push(tmpObj);
    }
    console.log(this.relateToLocation);
  }

  updateConsequences() {
    this.debouncer.next(this.relateToLocation);
  }

  removeConsequence(consequence) {
    this.relateToLocation.splice(this.relateToLocation.indexOf(consequence), 1);
    this.updateConsequences();
  }
}
